import sendGaComponentEvent from '@gcloud-npm/utils.metrics.send-ga-component-event';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import getCookie from '@gcloud-npm/utils.common.get-cookie';
import { LOGIN_URL, CLIENT_TYPE } from '@/constants/constant';

const parsePrice = (
  number,
  decimals,
  decimalChar = ',',
  thousandChar = '.'
) => {
  let res = number;
  res = res.toString().replace(',', thousandChar);
  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);
  const splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  if (splitNum[1] !== '00') {
    res = splitNum.join(decimalChar);
  } else {
    [res] = splitNum;
  }
  return res;
};

export const normalizePrice = (amount, decimals) => {
  const priceToShow = amount;
  if (!priceToShow && priceToShow !== 0) {
    return null;
  }
  if (!(typeof priceToShow === 'number' || typeof priceToShow === 'string')) {
    return null;
  }
  return parsePrice(priceToShow, decimals);
};

export const capitalizeWords = (str) =>
  str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const isClient = () => {
  const COOKIE_NAME_LOGGED = 'seth-session-logged';
  const sethLogged = getCookie(COOKIE_NAME_LOGGED);
  return !!sethLogged;
};

export const getClientType = () => {
  const COOKIE_LOGGED = 'seth-session-logged';
  const COOKIE_SOFT_LOGGED = 'seth-session-softlogged';
  const sethLogged = getCookie(COOKIE_LOGGED);
  const sethSoftLogged = getCookie(COOKIE_SOFT_LOGGED);

  let result;

  if (sethLogged) {
    result = CLIENT_TYPE.CLIENT;
  } else if (sethSoftLogged) {
    result = CLIENT_TYPE.SOFT_CLIENT;
  } else {
    result = CLIENT_TYPE.NO_CLIENT;
  }
  return result;
};

export const getUrlParamsString = () => {
  let searchParams = '';
  try {
    searchParams = window.location.search;
  } catch (err) {
    // Nothing to do
  }
  return searchParams;
};

export const sendTaggingInfo = (taggingInfo, eventType, eventName = null) => {
  const finalTaggingInfo = {
    ...taggingInfo,
    eventType,
  };
  try {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const isFrontApp = typeof window !== 'undefined';
    const isMetricsDevEnable =
      isFrontApp && window.location.search.indexOf('metrics') > -1;
    if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
      if (eventName) {
        sendGaComponentEvent(finalTaggingInfo, { eventType: eventName });
      } else {
        sendGaComponentEvent(finalTaggingInfo);
      }
    }
  } catch (err) {
    const sonda = new FrontSonda({
      processName: `input-${process.env.NEXT_PUBLIC_PROJECT_ID}`,
      filePath: `input-${window.location.href}`,
    });
    sonda.errorMessage(err);
    throw err;
  }
};

export const sendDynaInfo = (actionName, key, value, hint) => {
  if (window.dtrum && window.dtrum.enterAction) {
    const action = window.dtrum.enterAction(actionName);
    if (action) {
      window.dtrum.reportCustomError(key, value, hint, action);
      window.dtrum.leaveAction(action);
    }
  }
};

export const sendDynaJSError = (jsError) => {
  try {
    if (window.dtrum) {
      const customError = jsError;
      const cookie = getCookie('_ga');
      customError.message = `${jsError.message}--${cookie}`;
      window.dtrum.reportError(jsError);
    }
  } catch (e) {
    // Nothing to do
  }
};

export const reportJSError = (error, processName, filePath, context) => {
  try {
    if (error instanceof Error) {
      const sonda = new FrontSonda({
        processName,
        filePath,
        context,
      });
      sonda.errorMessage({ error });
    }
  } catch (e) {
    // Nothing to do
  }
};

export const goLoginUrlWithRedirect = (redirectUrl) => {
  const encodeRedirectUrl = encodeURIComponent(redirectUrl);
  const urlFinal = `${LOGIN_URL}?redirect=${encodeRedirectUrl}`;
  document.location.href = urlFinal;
};
export const getLoginUrlWithRedirect = (redirectUrl) => {
  const encodeRedirectUrl = encodeURIComponent(redirectUrl);
  const urlFinal = `${LOGIN_URL}?redirect=${encodeRedirectUrl}`;
  return urlFinal;
};

export const normalizeStringToDateObj = (strDate) => {
  const defaultDate = new Date(strDate);
  const year = defaultDate.getFullYear();
  const month = defaultDate.getMonth() + 1;
  const day = defaultDate.getDate();
  return { day, month, year };
};
export const getDayFromTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}h`;
};
export const availableSelectedDate = (date, availableDays) => {
  const { day, month, year } = { ...date };
  const selectedDate =
    Array.isArray(availableDays) &&
    availableDays.length > 0 &&
    availableDays.find(
      (item) =>
        item.day &&
        item.day.day === day &&
        item.day.month === month &&
        item.day.year === year
    );
  return selectedDate;
};
